import BaseTable from 'components/Tables/BaseTable';

export default function GroupDevicesTable({
  groupDevices,
  columns,
  selectedDeviceId,
  onSelectDevice,
}) {
  return (
    <BaseTable
      columns={columns}
      rows={groupDevices}
      enableRowVirtualization={groupDevices.length > 25}
      onRowClick={(device) => onSelectDevice(device.id === selectedDeviceId ? null : device.id)}
      selectedRowId={selectedDeviceId}
      customStyles={{
        cell: {
          color: 'var(--color-font)',
          borderBottom: '1px solid var(--color-divider)',
        },
        header: { backgroundColor: 'var(--color-primary)' },
      }}
    />
  );
}
